export default {plugin:{serarch_info:{ui:{search_by:'Search by'}}}};